import React from 'react';
import { Shield, CheckCircle, Truck, Phone, Award, Clock } from 'lucide-react';

/**
 * TrustBlock — Bloc de confiance réutilisable
 * Utilisable sur: produit, panier, devis, homepage
 */
export default function TrustBlock({ compact = false, className = '' }) {
  const items = [
    { icon: <Shield size={compact ? 14 : 18} />, label: 'Paiement sécurisé', sub: 'Stripe SSL', color: '#1F9D7A' },
    { icon: <CheckCircle size={compact ? 14 : 18} />, label: 'Matériel vérifié', sub: 'Inspecté avant chaque sortie', color: 'var(--teal)' },
    { icon: <Truck size={compact ? 14 : 18} />, label: 'Livraison & installation', sub: 'Rayon 1h30 Figeac', color: '#C58B19' },
    { icon: <Clock size={compact ? 14 : 18} />, label: 'Retour lendemain 10H', sub: 'Créneau flexible', color: '#B94B5C' },
    { icon: <Phone size={compact ? 14 : 18} />, label: 'Support disponible', sub: '07 56 87 66 65', color: 'var(--teal)' },
    { icon: <Award size={compact ? 14 : 18} />, label: '4.6 ★ avis clients', sub: '9 avis vérifiés', color: '#D4AF37' },
  ];

  if (compact) {
    return (
      <div className={`flex flex-wrap gap-3 ${className}`}>
        {items.slice(0, 4).map((item, i) => (
          <div key={`col-${i}`} className="flex items-center gap-1.5 text-xs" style={{ color: 'var(--text-muted)' }}>
            <span style={{ color: item.color }}>{item.icon}</span>
            {item.label}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`grid grid-cols-2 sm:grid-cols-3 gap-3 ${className}`}>
      {items.map((item, i) => (
        <div key={`col-${i}`} className="flex items-start gap-2.5 p-3 rounded-xl"
          style={{ background: '#FFFFFF', border: '1px solid var(--border)' }}>
          <div className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ background: `${item.color}15`, color: item.color }}>
            {item.icon}
          </div>
          <div>
            <p className="text-xs font-semibold" style={{ color: 'var(--ink)' }}>{item.label}</p>
            <p className="text-xs" style={{ color: 'var(--text-muted)' }}>{item.sub}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
